import { zIndex } from '@/features/world-map/utils/layer';
import { AdvancedMarker, useAdvancedMarkerRef } from '@vis.gl/react-google-maps';
import { useEffect } from 'react';
import { PlaceMarkerPin } from '../../place-marker-pin';

/**
 * @param {object} props
 * @param {string} [props.ariaLabel]
 * @param {google.maps.LatLngLiteral} props.position
 * @param {(marker: google.maps.marker.AdvancedMarkerElement) => void} props.onClick
 * @returns {React.JSX.Element}
 */
export function PlaceMarker({ ariaLabel = '', position, onClick }) {
  const [markerRef, marker] = useAdvancedMarkerRef();

  /** @this {google.maps.marker.AdvancedMarkerElement} */
  function handleOnClick() {
    onClick(this);
  }

  useEffect(() => {
    if (marker) {
      marker.ariaLabel = ariaLabel;
    }
  }, [marker, ariaLabel]);

  return (
    <AdvancedMarker
      ref={markerRef}
      style={{ lineHeight: 0 }}
      position={position}
      onClick={handleOnClick}
      zIndex={zIndex.place}
    >
      <PlaceMarkerPin />
    </AdvancedMarker>
  );
}
